module.exports = __webpack_public_path__ + "media/images/countryrect/gh-0e010f708b7538effc6019f065d801be.svg";